/**
 * Created by Carsten Bühler
 * User: CBuehler on 29.01.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import { AppContext } from 'plugin/liferay-widgets-react-web';
import { NumberSelect } from 'plugin/base-portlet';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { getStateStore } from '../stores/StoreFactory';
import { Col, Row } from 'external/react-bootstrap';
import StateValueLabel from './StateValueLabel';

let StateStore = getStateStore(AppContext);

class StateSelect extends React.Component {

  constructor(props) {
    super(props);
    const state = this.getCurrentState();
    if (state) {
      this.props.onChange(parseInt(state.id));
    }
  }

  onStateChanged(id) {
    this.props.onChange(id);
  }

  render() {
    let states = this.getStates();
    let state = this.getCurrentState();
    const { showLabel = true } = this.props;
    return (
      <Row>
        <Col xs={12}>
          <NumberSelect
            list={states}
            currentValue={state ? state.id : -1}
            defaultOption={null}
            onChange={this.onStateChanged.bind(this)}
          />
        </Col>
        {showLabel &&
          <Col xs={12}>
            <StateValueLabel item={{ state }}/>
          </Col>}
      </Row>
    );
  }

  getStates() {
    return StateStore.getStatesByClassNamePropName(this.props.className, this.props.propName).filter(s => s.active).map(s => ({
      value: s.id,
      label: s.stateTitle
    }));
  }

  getCurrentState() {
    const states = this.getStates();
    const filtered = this.props.currentKey && states.filter(v => v.value == this.props.currentKey),
      current = filtered && filtered.length > 0 ? filtered[0] : undefined;
    return states && states.length > 0 ? StateStore.getStateByClassNamePropNameStateId(this.props.className, this.props.propName, this.state && this.state.currentValue || (current || states[0]).value) : undefined;
  }
}

StateSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  propName: PropTypes.string.isRequired,
  currentKey: PropTypes.number,
  showLabel: PropTypes.bool,
};

export default StateSelect;



// WEBPACK FOOTER //
// ./js/components/StateSelect.jsx